<template>
  <div class="card mt-3 in-product-varieties">
    <div class="card-header border-0">
      <h5 class="card-title">انتخاب رنگ ها</h5>
      <div style="flex:1"></div>
    </div>
    <div class="card-body">
      <InputGroup label=" نوع رنگ  ">
        <treeselect
          :searchable="true"
          :multiple="true"
          :options="allAttributes"
         
          valueFormat="object"
          noChildrenText="فرزندی وجود ندارد"
          noOptionsText="موردی وجود ندارد"
          noResultsText="موردی یافت نشد"
          placeholder="انتخاب ویژگی ها"
          v-model="selectedallAttributes"
        ></treeselect>
      </InputGroup>
      <b-form-group
        v-if="allAttributes &&selectedallAttributes&&selectedallAttributes.length"
      >
        <div
          class=" mt-3"
          v-for="attribute in selectedallAttributes"
          :key="attribute.id"
        >
        
          <h6>
            مقادیر <span class="font-weight-bold">{{attribute.label }}</span>
          </h6>
          <treeselect
          :searchable="true"
          :multiple="true"
         
          :normalizer="normalizer" 
          v-model="colorsItems[attribute.id]"
          :options="attribute.values"
          @input="changColorsItems"
          valueFormat="object"
          noChildrenText="فرزندی وجود ندارد" 
          noOptionsText="موردی وجود ندارد"
          noResultsText="موردی یافت نشد"
          placeholder="انتخاب ویژگی ها"
        >
    
      </treeselect>
       
        </div>
      </b-form-group>

    </div>
  </div>
</template>

<script>
import ProductColorsImpl from "@@/core/components/product/Colors/ProductColorsImpl.js";
import Dropdown from "@@/core/components/shared/Dropdown/Dropdown";
export default {
  components: { Dropdown },
  extends: ProductColorsImpl,
};
</script>
